const Checkmark = ({ className = '', color = 'white', height = '20', width = '20' }) => (
  <svg
    className={className}
    data-testid="Checkmark"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.92259 10.2441C3.59715 9.91864 3.06951 9.91864 2.74408 10.2441C2.41864 10.5695 2.41864 11.0972 2.74408 11.4226L6.91074 15.5893C7.23618 15.9147 7.76382 15.9147 8.08926 15.5893L17.2559 6.42259C17.5814 6.09715 17.5814 5.56951 17.2559 5.24408C16.9305 4.91864 16.4028 4.91864 16.0774 5.24408L7.5 13.8215L3.92259 10.2441Z"
      fill={color}
    />
  </svg>
);

Checkmark.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default Checkmark;
